<template>
  <div class="tasks">
    <TextTable
      :all_data = "all_data"
    />
  </div>
</template>
<script>

import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'Device_tasks',
  components: {
    TextTable
  },
  props: ['dev_id'],

  data () {
    return {
      all_data: {}
    }
  },
  mounted () {
    this.$http.v1.getDeviceTask(this.dev_id, (response) => {
      this.all_data = response.data
    })
  }
}

</script>
<style lang="scss" scoped>
.tasks{
  height: 100%;
}

</style>
